import { yup } from '@guiker/yup-util'

export const readOneListingLeadListingQueryParamsSchema = yup.object({
  includeAllOptions: yup.boolean().notRequired().default(false),
})

export type ReadOneListingLeadListingQueryParamsSchema = yup.InferType<
  typeof readOneListingLeadListingQueryParamsSchema
>
